import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { useEffect, useState } from 'react';
import { Row, Col, Typography, Empty, DatePicker, Statistic } from 'antd'
import Box from '../../components/utility/box';
import moment from "moment";
import systemActions from '../../redux/systemInfos/actions';
import { getWeeklyStatisticsOfWeek } from '../../redux/systemInfos/selectors';

const { Title } = Typography;

const {
  getWeeklyStatistics
} = systemActions;

function WeeklyStatistics(props) {
  const [currentMomentDate, setCurrentMomentDate] = useState(moment().add(-1, 'week').endOf('week'));
  const [currentDateStatistics, setCurrentDateStatistics] = useState(undefined);

  useEffect(() => {
    const yesterdaysStatistics = props.getWeeklyStatisticsOfWeekFn(currentMomentDate.isoWeek());
    if (!yesterdaysStatistics) {
      props.getWeeklyStatistics(currentMomentDate);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCurrentDateStatistics(props.getWeeklyStatisticsOfWeekFn(currentMomentDate.isoWeek()))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.weeklyStatistics]);

  useEffect(() => {
    const existingStatistics = props.getWeeklyStatisticsOfWeekFn(currentMomentDate.isoWeek());
    if (!existingStatistics) props.getWeeklyStatistics(currentMomentDate);
    else setCurrentDateStatistics(existingStatistics);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMomentDate]);

  return (
    <Box>
      <Row>
        <Col span={24}>
          <Title level={4} style={{ textAlign: "center" }}>
            <span>Weekly statistics  </span>
            <DatePicker.WeekPicker allowClear={false} value={currentMomentDate} onChange={(newDate) => setCurrentMomentDate(newDate)} disabledDate={(currentDate) => currentDate.isSameOrAfter(moment(), 'week')} />
          </Title>
        </Col>
      </Row>
      {currentDateStatistics === undefined && <Empty />}
      {currentDateStatistics !== undefined && <Row>
        <Col span={12}>
          <Statistic title="Overall activity (total)" value={currentDateStatistics.overallActivity ? currentDateStatistics.overallActivity.total : '-'} />
        </Col>
        <Col span={12}>
          <Statistic title="Successfull logins (total)" value={currentDateStatistics.successfullLogIns ? currentDateStatistics.successfullLogIns.total : '-'} />
        </Col>
      </Row>}
      {currentDateStatistics !== undefined && <Row>
        <Col span={12}>
          <Statistic title="Overall activity (daily average)" precision={1} value={currentDateStatistics.overallActivity ? currentDateStatistics.overallActivity.dailyAverage : '-'} />
        </Col>
        <Col span={12}>
          <Statistic title="Successfull logins (daily average)" precision={1} value={currentDateStatistics.successfullLogIns ? currentDateStatistics.successfullLogIns.dailyAverage : '-'} />
        </Col>
      </Row>}
    </Box>
  );
}

WeeklyStatistics.propTypes = {
  day: PropTypes.object,
  getWeeklyStatistics: PropTypes.func.isRequired,
  weeklyStatistics: PropTypes.array.isRequired,
  getWeeklyStatisticsOfWeekFn: PropTypes.func.isRequired
};

WeeklyStatistics.defaultProps = {
  day: moment()
}

function mapStateToProps(state) {
  return {
    getWeeklyStatisticsOfWeekFn: (weekNumber) => getWeeklyStatisticsOfWeek(state, weekNumber),
    weeklyStatistics: state.SystemInfos.get('weeklyStatistics'),
  };
}

const mapActionsToProps = {
  getWeeklyStatistics
};

const connectedPage = connect(mapStateToProps, mapActionsToProps)(WeeklyStatistics);
export default connectedPage;
